import { createTheme } from '@mui/material/styles'
import type {} from '@mui/x-data-grid-pro/themeAugmentation'
import { MENU_Z_INDEX } from '~components/navigation-and-footer/navigation/navigation'
import { COLORS } from './colors'
import { MuiAccordion } from './components/accordion'
import { MuiDataGrid } from './components/data-grid'
import { MuiTableCell } from './components/table-cell'
import { MuiTableRow } from './components/table-row'
import { MuiTable } from './components/table'
import { breakpoints, palette, spacing, typography } from './global'

const themeOptions = createTheme({
  breakpoints,
  palette,
  spacing,
  // @ts-ignore
  typography,
  components: {
    MuiDialog: {
      styleOverrides: {
        root: {
          zIndex: MENU_Z_INDEX + 1,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          '& .MuiDrawer-paper': {
            backgroundColor: COLORS.secondary.darkBlue,
          },
        },
      },
    },
    MuiAccordion,
    MuiDataGrid,
    MuiTableCell,
    MuiTableRow,
    MuiTable: { ...MuiTable, defaultProps: { variant: 'default' } },
    MuiTypography: {
      styleOverrides: {
        root: {
          '&:is(a)': {
            ...typography.link,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&.MuiButton-containedPrimary': {
            '&:hover': {
              backgroundColor: COLORS.secondary.barBlue,
            },
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: COLORS.primary.white,
          color: COLORS.secondary.darkBlue,
          fontSize: 14,
          cursor: 'pointer',
          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
          padding: 10,
          maxWidth: 305,
        },
      },
    },
  },
})

export default themeOptions
